import { SingleActionAlertProps, showSingleActionPopUp } from './singleAction'

import { evaluationModal, EvaluationModalProps } from './evaluationModal'
import { assignModal, AssignModalProps } from './assignModal'
import { DoubleActionAlertProps, showDoubleActionPopUp } from './doubleAction'
import { ConfirmationProps, showConfirmationPopUp } from './confirmationModal'
import { connectModal, ConnectModalProps } from './connectModal'
import { quickConnectModal, QuickConnectModalProps } from './quickConnectModal'
import { connectionDataModal, ConnectionDataModalProps } from './connectionDataModal'
import { StartupAlreadyExistsModal, StartupAlreadyExistsModalProps } from './startupAlreadyExistsModal'

export const showModal = (
  type: string,
  info: SingleActionAlertProps | DoubleActionAlertProps | EvaluationModalProps | AssignModalProps | ConnectModalProps | QuickConnectModalProps | ConnectionDataModalProps | ConfirmationProps
): void => {
  switch (type) {
    case 'single':
      showSingleActionPopUp(info as SingleActionAlertProps)
      break
    case 'double':
      showDoubleActionPopUp(info as DoubleActionAlertProps)
      break
    case 'confirmation':
      showConfirmationPopUp(info as ConfirmationProps)
      break
    case 'evaluationModal':
      evaluationModal(info as EvaluationModalProps)
      break
    case 'assignModal':
      assignModal(info as AssignModalProps)
      break
    case 'connect':
      connectModal(info as ConnectModalProps)
      break
    case 'quickConnect':
      quickConnectModal(info as QuickConnectModalProps)
      break
    case 'connectionData':
      connectionDataModal(info as ConnectionDataModalProps)
      break
    case 'startupAlreadyExists':
      StartupAlreadyExistsModal(info as StartupAlreadyExistsModalProps)
      break
    default:
      break
  }
}
